import React from "react";
import { Link } from "react-router-dom";

function Contact_header(){

    return(
        <div className="contact-header">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>تماس با ما</h1>
                        <div className="breadcrumbs">
                            <Link to="/">صفحه اصلی</Link>
                            <i className="fas fa-angle-left"></i>
                            <span className="current-page">تماس با ما</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Contact_header;